import { IDonorStatus, IDonorRegistration, IListItem } from '@nkr/models/index';
import { IDashRemoteStatus } from '@nkr/models/donor-status-by-center';
import { IDashWorkFlowStatusRequest } from '@nkr/models/dash-workflow-status-request';
import { ViewWrapper } from '../styles';
import { ICoordinator } from '../coordinator';
import ViewDonorRegistrationData from './view-donor-registration-data';

interface IProps {
    centerId: number,
    data: IDonorRegistration,
    dataList: IDonorRegistration[],
    statusList: IDonorStatus[],
    remoteStatusList: IDashRemoteStatus[],
    actionList: IListItem[],
    coordinatorList: ICoordinator[],
    ruleOutReasons: Array<{ id: number; description: string }>,
    isMobile: boolean,
    onStatusChange: (request: IDashWorkFlowStatusRequest) => void,
    onSaveCenterCard?: () => void | Promise<void>,
    onSaveNetworkCard?: () => void | Promise<void>,
    onDataChange: (field: string, value: any) => void,
    onSaveLogEntry: (dashRegistrationId: number, actionTaken: number, comments: string) => void,
    onUpdateLogEntry: (id: number, dashRegistrationId: number, actionTaken: number, comments: string) => void,
    onDeleteLogEntry: (id: number, dashRegistrationId: number) => void,
    onItemSelected: (id: number, action: number) => void,
    onRuleOut: (donorId: number, reasonId: number, allowReRegistration: boolean, useNkrAssistance: boolean, coordinatorName?: string, phoneNumber?: string, medicalReasonCategory?: number, medicalReasonNotes?: string) => void,
    statusFormBaselineKey?: number,
}

const ViewDonorRegistration = (props: IProps) => {
    const { dataList } = props;

    if (!props.isMobile) {
        return (
            <ViewWrapper>
                <div className='modal-container'>
                    <ViewDonorRegistrationData
                        centerId={props.centerId}
                        data={props.data}
                        statusList={props.statusList}
                        remoteStatusList={props.remoteStatusList}
                        actionList={props.actionList}
                        coList={props.coordinatorList}
                        ruleOutReasons={props.ruleOutReasons}
                        statusFormBaselineKey={props.statusFormBaselineKey}
                        onStatusChange={props.onStatusChange}
                        onDataChange={props.onDataChange}
                        onSaveCenterCard={props.onSaveCenterCard}
                        onSaveNetworkCard={props.onSaveNetworkCard}
                        onSaveLogEntry={props.onSaveLogEntry}
                        onUpdateLogEntry={props.onUpdateLogEntry}
                        onDeleteLogEntry={props.onDeleteLogEntry}
                        onItemSelected={props.onItemSelected}
                        onRuleOut={props.onRuleOut}
                    />
                </div>
            </ViewWrapper>
        );
    } else {
        return (
            <div>
                {dataList.map(d =>
                    <ViewDonorRegistrationData
                        key={d.id}
                        data={d}
                        centerId={props.centerId}
                        statusList={props.statusList}
                        remoteStatusList={props.remoteStatusList}
                        actionList={props.actionList}
                        coList={props.coordinatorList}
                        ruleOutReasons={props.ruleOutReasons}
                        statusFormBaselineKey={props.statusFormBaselineKey}
                        onStatusChange={props.onStatusChange}
                        onDataChange={props.onDataChange}
                        onSaveCenterCard={props.onSaveCenterCard}
                        onSaveNetworkCard={props.onSaveNetworkCard}
                        onSaveLogEntry={props.onSaveLogEntry}
                        onUpdateLogEntry={props.onUpdateLogEntry}
                        onDeleteLogEntry={props.onDeleteLogEntry}
                        onItemSelected={props.onItemSelected}
                        onRuleOut={props.onRuleOut}
                    />
                )}
            </div>
        );
    }
}

export default ViewDonorRegistration;